import axios from "axios"

export function getRecallDetail (id) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/recall/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};